module.exports = __webpack_public_path__ + "img/kx5200-char-5.ec92d8b2.png";